import React from "react";

export default function WhyItMatters() {
  return (
    <div>
      {/* Why It Matters Section */}
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "60px 20px 40px",
        }}
      >
        <h2
          style={{
            fontSize: "2rem",
            fontWeight: "700",
            marginBottom: "20px",
            color: "#1a1a1a",
          }}
        >
          Why It Matters
        </h2>
        <p
          style={{
            fontSize: "1rem",
            lineHeight: "1.7",
            color: "#4a5568",
            maxWidth: "900px",
          }}
        >
          U.S. drug prices are among the highest in the world. But change starts
          with people like you. With just a few clicks, you can speak up for
          transparency and fairness.
        </p>
      </div>

      {/* Responsive Styles */}
      <style>{`
        @media (max-width: 768px) {
          h2 {
            font-size: 1.75rem !important;
          }
          h3 {
            font-size: 2rem !important;
          }
          div[style*="padding: 40px 30px"] {
            padding: 30px 20px !important;
          }
        }
        
        @media (max-width: 480px) {
          h2 {
            font-size: 1.5rem !important;
          }
          h3 {
            font-size: 1.75rem !important;
          }
          div[style*="fontSize: 3rem"] {
            font-size: 2.5rem !important;
          }
        }
      `}</style>
    </div>
  );
}